module.exports = __webpack_public_path__ + "img/2.ac123faa.png";